import { Component, Input } from '@angular/core';
import { AbstractControl } from '@angular/forms';
import { TranslateModule } from '@ngx-translate/core';

@Component({
  selector: 'gk-min-max-alert',
  imports: [TranslateModule],
  template: `
    <div class="alert alert-danger mt-2" role="alert">
      @let minError = formControlInstance?.getError('min');
      @if (minError) {
        {{ 'MIN_ERROR' | translate: { min: minError.min } }}
      }
      @let maxError = formControlInstance?.getError('max');
      @if (maxError) {
        {{ 'MAX_ERROR' | translate: { max: maxError.max } }}
      }
    </div>
  `,
})
export class GkMinMaxAlertComponent {
  @Input() formControlInstance: AbstractControl;
}
